import { createContext, useContext, useEffect, useState } from 'react';
import { getEmploymentTypeList } from '../api/employmentTypes';
import { EmploymentType } from '../types';
import { useTranslation } from 'react-i18next';

const EmploymentTypesContext = createContext<EmploymentType[]>([]);

const useEmploymentTypes = () => {
  return useContext(EmploymentTypesContext);
};

// !WB: I wrote this quickly and then realised there's actually a redux store already on the app. Maybe I should have used that..
export const EmploymentTypesProvider: React.FC = ({ children }) => {
  const [employmentTypes, setEmploymentTypes] = useState<EmploymentType[] | null>(null)

  useEffect(() => {
    if (employmentTypes) return;
    getEmploymentTypeList().then((res) => {
      setEmploymentTypes(res.data);
    })
  }, [employmentTypes]);

  return (
    <EmploymentTypesContext.Provider value={employmentTypes || []}>
      {children}
    </EmploymentTypesContext.Provider>
  );
}

export const useGetEmploymentTypeNameById = () => {
  const { t } = useTranslation();

  // Map employment type IDs to translation keys
  const getTranslationKey = (id: string): string => {
    switch (id) {
      case 'permanent':
        return 'EMPLOYMENT_TYPE_PERMANENT';
      case 'freelance':
        return 'EMPLOYMENT_TYPE_FREELANCE';
      case 'ctp':
        return 'EMPLOYMENT_TYPE_CTP';
      case 'temporary':
        return 'EMPLOYMENT_TYPE_TEMPORARY';
      default:
        // Fallback to a generic employment type key or the ID itself
        return `EMPLOYMENT_TYPE_${id.toUpperCase()}`;
    }
  };

  return (id: string) => {
    const translationKey = getTranslationKey(id);
    const translatedName = t(translationKey);

    // If translation is missing, fallback to the translation key (which would show the key itself)
    // This helps identify missing translations during development
    return translatedName !== translationKey ? translatedName : translationKey;
  };
}

export default useEmploymentTypes;